<template>
  <div class="Menu">
    <b-row class="container" style="margin:auto">
      <template v-if="isMobile(true)">
        <b-row>
          <b-col sm="6" class="mobileWidth">
            <div class="numberMob container"><a class="phonenumber" href="tel:01825 280050">01825 280050</a></div>
          </b-col>
          <b-col sm="6" class="mobileWidth">
            <b-link href="https://simpark.club/gift-vouchers" target="_blank">
              <div class="pulseMob">
                <button class="buyGiftVoucherMob">Gift Voucher</button>
              </div>
            </b-link>
          </b-col>
        </b-row>
      </template>
      <template v-else>
        <b-col lg="4" sm="12">
          <b-row>
            <b-col class="topIcon">
              <a href="https://www.instagram.com/flightpark_maresfield" target="_blank" class="socialIconsTopp">
                <img class="Sicon" src="https://wp-ocssport.ocs-sport.com/flightpark/wp-content/uploads/sites/6/2026/09/instagram_blue.png">
              </a>
            </b-col>
            <b-col class="topIcon mid">
              <a href="https://www.tiktok.com/@simpark_maresfield?_r=1&_t=ZN-99kl3LTnatu" target="_blank" class="socialIconsTopp">
                <img class="Sicon" src="https://wp-ocssport.ocs-sport.com/flightpark/wp-content/uploads/sites/6/2026/09/tiktok_blue.png">
              </a>
            </b-col>
            <b-col class="topIcon">
              <a href="https://www.facebook.com/profile.php?id=61573207374451&mibextid=wwXIfr&rdid=iPXzehEbsp0FBGlb&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F19SyiaVtDj%2F%3Fmibextid%3DwwXIfr#" target="_blank" class="socialIconsTopp">
                <img class="Sicon" src="https://wp-ocssport.ocs-sport.com/flightpark/wp-content/uploads/sites/6/2026/09/facebook_blue.png">
              </a>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="8" sm="12">
          <b-row class="callSec">
            <b-col lg="8" sm="12">
              <div class="number container">Call Us On : <a class="phonenumber" href="tel:01825 280050">01825 280050</a></div>
            </b-col>
            <b-col lg="4" sm="12">
              <b-link href="https://simpark.club/gift-vouchers" target="_blank">
                <div class="pulse">
                  <div class="buyText">Buy a Gift Voucher</div>
                </div>
              </b-link>
            </b-col>
          </b-row>
        </b-col>
      </template>
    </b-row>
    <b-navbar toggleable="lg" type="light" variant="info" class="container">
        <b-navbar-brand href='/'>
            <b-img class="logo" src="https://wp-ocssport.ocs-sport.com/flightpark/wp-content/uploads/sites/6/2024/11/FlightPark_V2.png"></b-img>
            <!-- <span class="clubText">.club</span> -->
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <template v-if="this.$route.name == 'home'">
          <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav class="ml-auto">
                  <b-nav-item class="navItems" @click="scroll()">About</b-nav-item>
                  <b-nav-item class="navItems" @click="scrolltwo()">Memberships</b-nav-item>
                  <!-- <b-nav-item class="navItems"  href="https://simpark.club/gift-vouchers" target="_blank">Gift Vouchers</b-nav-item> -->
                  <!-- <b-nav-item class="navItems" href="https://simpark.club/" target="_blank">
                    <img class="golfParkLogo" src="https://wp-ocssport.ocs-sport.com/simpark/wp-content/uploads/sites/5/2025/02/SimPark.png">
                  </b-nav-item> -->
                  <b-nav-item class="navItems" href="https://racepark.club/" target="_blank">
                    <img style="height: 30px;" class="golfParkLogo" src="https://wp-ocssport.ocs-sport.com/racepark/wp-content/uploads/sites/7/2024/11/RacePark.png">
                  </b-nav-item>
                  <b-nav-item class="navItems" href="https://golfpark.club/" target="_blank">
                    <img class="golfParkLogo" src="https://wp-ocssport.ocs-sport.com/golfpark/wp-content/uploads/sites/4/2024/06/GolfPark_Colour_Logo.png">
                  </b-nav-item>
                  <b-nav-item
                    class="navItems review-nav"
                    href="https://simpark.club/review"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div class="review-button">
                      <b-icon icon="star-fill" class="review-icon"></b-icon>
                      <span class="buyTextRed">Review Us</span>
                    </div>
                  </b-nav-item>
                  <!-- <template v-if="isMobile(true)">
                    <b-nav-item class="navItems" :href="'https://apps.apple.com/gb/app/sim-park/id6738054804'" target="_blank">
                      <img class="storeIcons" src="https://wp-ocssport.ocs-sport.com/flightpark/wp-content/uploads/sites/6/2024/11/Group-85.png">
                       Download App
                    </b-nav-item>
                    <b-nav-item class="navItems" :href="'https://play.google.com/store/apps/details?id=com.ocssoftware.simpark.app'" target="_blank">
                      <img class="storeIcons" src="https://wp-ocssport.ocs-sport.com/flightpark/wp-content/uploads/sites/6/2024/11/Group-84.png">
                      Download App
                    </b-nav-item>
                  </template> -->
                  <!-- <template v-else>
                    <b-nav-item class="navItems appleStoreItem" :href="'https://apps.apple.com/gb/app/sim-park/id6738054804'" target="_blank">
                      <img class="storeIcons" src="https://wp-ocssport.ocs-sport.com/flightpark/wp-content/uploads/sites/6/2024/11/Group-85.png">
                    </b-nav-item>
                    <b-nav-item class="navItems goolgeStoreItem" :href="'https://play.google.com/store/apps/details?id=com.ocssoftware.simpark.app'" target="_blank">
                      <img class="storeIcons" src="https://wp-ocssport.ocs-sport.com/flightpark/wp-content/uploads/sites/6/2024/11/Group-84.png">
                    </b-nav-item>
                  </template> -->
              </b-navbar-nav>
          </b-collapse>
        </template>
        <template v-else>
          <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav class="ml-auto">
                  <b-nav-item class="navItems" to="/">About</b-nav-item>
                  <b-nav-item class="navItems" to="/">Memberships</b-nav-item>
                  <!-- <b-nav-item class="navItems"  href="https://simpark.club/gift-vouchers" target="_blank">Gift Vouchers</b-nav-item> -->
                  <!-- <b-nav-item class="navItems" href="https://simpark.club/" target="_blank">
                    <img class="golfParkLogo" src="https://wp-ocssport.ocs-sport.com/simpark/wp-content/uploads/sites/5/2025/02/SimPark.png">
                  </b-nav-item> -->
                  <b-nav-item class="navItems" href="https://racepark.club/" target="_blank">
                    <img class="golfParkLogo" src="https://wp-ocssport.ocs-sport.com/racepark/wp-content/uploads/sites/7/2024/11/RacePark.png">
                  </b-nav-item>
                  <b-nav-item class="navItems" href="https://golfpark.club/" target="_blank">
                    <img class="golfParkLogo" src="https://wp-ocssport.ocs-sport.com/golfpark/wp-content/uploads/sites/4/2024/06/GolfPark_Colour_Logo.png">
                  </b-nav-item>
                  <template v-if="isMobile(true)">
                    <b-nav-item class="navItems" :href="'https://apps.apple.com/gb/app/sim-park/id6738054804'" target="_blank">
                      <img class="storeIcons" src="https://wp-ocssport.ocs-sport.com/flightpark/wp-content/uploads/sites/6/2024/11/Group-85.png">
                       Download App
                    </b-nav-item>
                    <b-nav-item class="navItems" :href="'https://play.google.com/store/apps/details?id=com.ocssoftware.simpark.app'" target="_blank">
                      <img class="storeIcons" src="https://wp-ocssport.ocs-sport.com/flightpark/wp-content/uploads/sites/6/2024/11/Group-84.png">
                      Download App
                    </b-nav-item>
                  </template>
                  <template v-else>
                    <b-nav-item class="navItems appleStoreItem" :href="'https://apps.apple.com/gb/app/sim-park/id6738054804'" target="_blank">
                      <img class="storeIcons" src="https://wp-ocssport.ocs-sport.com/flightpark/wp-content/uploads/sites/6/2024/11/Group-85.png">
                    </b-nav-item>
                    <b-nav-item class="navItems goolgeStoreItem" :href="'https://play.google.com/store/apps/details?id=com.ocssoftware.simpark.app'" target="_blank">
                      <img class="storeIcons" src="https://wp-ocssport.ocs-sport.com/flightpark/wp-content/uploads/sites/6/2024/11/Group-84.png">
                    </b-nav-item>
                  </template>
              </b-navbar-nav>
          </b-collapse>
        </template>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  props: {

  },
  methods: {
      isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
    scroll() {
      var score = document.getElementById("about");
      score.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
    scrolltwo() {
      var score = document.getElementById("membership");
      score.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
    // scrollthree() {
    //   var score = document.getElementById("contact");
    //   score.scrollIntoView({
    //     behavior: "smooth",
    //     block: "start",
    //     inline: "nearest",
    //   });
    // },
    // scrollfour() {
    //   var score = document.getElementById("blog");
    //   score.scrollIntoView({
    //     behavior: "smooth",
    //     block: "start",
    //     inline: "nearest",
    //   });
    // },
  },
  mounted() {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Review Us navigation button */
.review-nav {
  display: flex;
  align-items: center;
}

.review-nav .nav-link {
  padding: 0.35rem 0.5rem;
}

.review-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 9px 16px;
  background: #ffffff;
  color: #5D8EF0;
  border: 2px solid #5D8EF0;
  border-radius: 8px;
  font-weight: 800;
  font-size: 14px;
  line-height: 1.2;
  white-space: nowrap;
  box-shadow: 0 0 0 0 rgba(215, 25, 32, 0.4);
  animation: reviewPulse 2.5s infinite;
  transition:
    background 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease;
}

.review-button:hover .buyTextRed,
.review-button:hover .review-icon {
  color: #ffffff !important;
}
.review-button:hover {
  background: #5D8EF0;
  color: #ffffff!important;
  transform: translateY(-2px);
  box-shadow: 0 4px 14px rgba(215, 25, 32, 0.35);
  animation: none;
}
.review-icon {
  font-size: 13px;
}
  .buyTextRed {
    color: #5D8EF0;
    font-size: 18px;
    font-weight: 700;
    font-family: noto-sans, sans-serif;
  }
@keyframes reviewPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(215, 25, 32, 0.35);
  }
  70% {
    box-shadow: 0 0 0 7px rgba(215, 25, 32, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(215, 25, 32, 0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .review-button {
    animation: none;
    transition: none;
  }
}
  .mid {
    max-width: 11%!important;
  }
  .topIcon {
      width: 12%;
      max-width: 12%;
  }
  img.Sicon {
      width: 42px;
  }
  a:hover {
    color: #0056b3;
    text-decoration: none;
  }
  .callSec {
    margin-right: 4px;
    margin-bottom: 17px;
  }
  .buyText {
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    font-family: noto-sans, sans-serif;
  }
  .nonPulse {
    font-size: 18px;
    font-weight: bold;
    font-family: "noto-sans", sans-serif;
    color: #fff;
    position: absolute;
    /* right: -15px; */
    right: 0px;
    top: 4px;
  }
  ::v-deep .pulse{
    height: 40px;
    background: #ff001e;
    border-radius: 50px;
    color: #FFF;
    font-size: 20px;
    text-align: center;
    line-height: 40px;
    font-family: sans-serif;
    animation: animate-pulse-9bcc0be2 3s linear infinite;
    cursor: pointer;
  }
  @keyframes animate-pulse{
      0%{
          box-shadow: 0 0 0 0 rgba(255,109,74,0.7),  0 0 0 0 rgba(255,109,74,0.7);
      }
      40%{
          box-shadow: 0 0 0 50px rgba(255,109,74,0.0),  0 0 0 0 rgba(255,109,74,0.7);
      }
      80%{
          box-shadow: 0 0 0 50px rgba(255,109,74,0.0),  0 0 0 30px rgba(255,109,74,0);
      }
      100%{
          box-shadow: 0 0 0 0 rgba(255,109,74,0.0),  0 0 0 30px rgba(255,109,74,0);
      }
      
  }
  .mobileWidth.col-sm-6 {
    width: 50%;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .buyGiftVoucher {
    background-color: #d80e1f;
    border-color: #d80e1f !important;
    border-radius: 50px;
    width: 163px;
    height: 31px;
    line-height: 1;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    width: 200px;
    height: 35px;
    /* margin-top: 65px; */
    font-family: "noto-sans", sans-serif;
    border: none;
    z-index: 99;
    cursor: pointer;
    margin-left: 6em;
  }
  /* .buyGiftVoucher:hover {
    background-color: #fff;
    border-color: #d80e1f !important;
    border-radius: 50px;
    width: 163px;
    height: 31px;
    line-height: 1;
    color: #000!important;
    font-size: 18px;
    font-weight: bold;
    width: 200px;
    height: 35px;
    font-family: "noto-sans", sans-serif;
    border: none;
    z-index: 99;
    cursor: pointer;
    margin-left: 6em;
  }
  .nonPulse:hover {
    font-size: 18px;
    font-weight: bold;
    font-family: "noto-sans", sans-serif;
    color: #000000!important;
    position: absolute;
    right: 0px;
    top: 4px;
  } */
  .phonenumber {
    color: #5D8EF0;
  }
  .phonenumber:hover {
    color: #000;
  }
  .number { 
    color: #5D8EF0;
    opacity: 1;
    text-align: right;
    font-weight: bold;
    /* padding-right: 50px; */
    font-size: 20px;
    margin-left: 1em;
    position: relative;
    top: 10px;
  }
  .numberMob { 
    color: #5D8EF0;
    opacity: 1;
    text-align: left;
    font-weight: bold;
    /* padding-right: 50px; */
    font-size: 20px;
  }
  .buyGiftVoucherMob {
    background-color: #d80e1f;
    border-color: #d80e1f !important;
    border-radius: 50px;
    width: 163px;
    height: 31px;
    line-height: 1;
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    width: 180px;
    height: 30px;
    /* margin-top: 65px; */
    font-family: "noto-sans", sans-serif;
    border: none;
    z-index: 99;
    cursor: pointer;
    float: right;
  }
  .buyGiftVoucherMob:hover {
    background-color: #ffffff;
    border-color: #d80e1f !important;
    border-radius: 50px;
    width: 163px;
    height: 31px;
    line-height: 1;
    color: #000;
    font-size: 15px;
    font-weight: bold;
    width: 180px;
    height: 30px;
    /* margin-top: 65px; */
    font-family: "noto-sans", sans-serif;
    border: none;
    z-index: 99;
    cursor: pointer;
    float: right;
  }
    img.golfParkLogo {
      /* width: 70px; */
      height: 30px;
    }
    li.nav-item.navItems.appleStoreItem {
      padding-right: 0px;
    }
    li.nav-item.navItems.goolgeStoreItem {
      padding-left: 0px;
    }
    img.storeIcons {
      width: 42px;
    }
    .clubText {
      color: #FF7600;
      font-style: italic;
      font-size: 29px;
      font-weight: bold;
      position: relative;
      top: 15px;
      left: -11px;
    }
    .Menu {
      /* display: none; */
    }
    .hide {
      opacity:0;
      display: none;
    }
    .show {
      opacity: 1;
      /* background: #010322; */
      /* position: fixed; */
      width: 100%;
      z-index: 999;
    }
    img.supportLogos {
      width: 45px;
    }
    ::v-deep .btn-danger {
      color: #fff;
      background-color: #efd170;
      border-color: #efd170!important;
    }
    .navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
        color: #5D8EF0;
    }
    .navItems {
        /* padding-right: 40px;
        padding-left: 40px; */
        padding-right: 10px;
        padding-left: 10px;
        line-height: 3;
        scroll-behavior: smooth;
        color:#fff;
    }
    .navItems:hover {
        /* padding-right: 30px;
        padding-left: 30px; */
        line-height: 3;
        scroll-behavior: smooth;
        color:rgb(232 63 75);
        text-decoration: none;
    }
    .logo {
        width: 190px;
    }
    .Menu {
        background-color: #FFFFFF !important;
        padding-top: 20px;
        padding-bottom: 20px;
    }
    .bg-info {
        background-color: #FFFFFF !important;
    }
    .navbar-light .navbar-nav .nav-link {
        color: #1A1A1A;
        font-size: 20px;
        font-family: "noto-sans", sans-serif;
        font-weight: 600;
        font-style: normal;
    }
    button.getInTouch {
        background-color: #5D8EF0;
        border-color: #5D8EF0!important;
        border-radius: 50px;
        width: 163px;
        height: 31px;
        line-height: 1;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        width: 259px;
        height: 54px;
    }
    button.getInTouch:hover {
        background-color: #707070;
        border-color: #707070!important;
        color: #fff;
    }
    @media only screen and (max-width: 768px) {
      .bg-info {
        background-color: #FFFFFF !important;
        z-index: 9999;
      }
    }
    @media only screen and (max-width: 500px) {
      .number { 
        color: #DD112B;
        opacity: 1;
        text-align: center;
        font-weight: bold;
        padding-right: 0px;
        font-size: 20px;
      }
      img.storeIcons {
          width: 35px;
          padding-right: 5px;
          margin-right: 5px;
      }
      .logo {
          width: 150px;
      }
      .Menu{
          padding-top: 5px;
          padding-bottom: 5px;
      }
      img.supportLogos {
          width: 50px;
          margin-top: 15px;
      }
    }
  @media only screen and (max-width: 375px) {
      .numberMob { 
      color: #DD112B;
      opacity: 1;
      text-align: left;
      font-weight: bold;
      /* padding-right: 50px; */
      font-size: 16px;
    }
    .buyGiftVoucherMob {
      background-color: #d80e1f;
      border-color: #d80e1f !important;
      border-radius: 50px;
      width: 163px;
      height: 31px;
      line-height: 1;
      color: #fff;
      font-size: 13px;
      font-weight: bold;
      width: 150px;
      height: 25px;
      /* margin-top: 65px; */
      font-family: "noto-sans", sans-serif;
      border: none;
      z-index: 99;
      cursor: pointer;
      float: right;
    }
    .buyGiftVoucherMob:hover {
      background-color: #ffffff;
      border-color: #d80e1f !important;
      border-radius: 50px;
      width: 163px;
      height: 31px;
      line-height: 1;
      color: #000000;
      font-size: 13px;
      font-weight: bold;
      width: 150px;
      height: 25px;
      /* margin-top: 65px; */
      font-family: "noto-sans", sans-serif;
      border: none;
      z-index: 99;
      cursor: pointer;
      float: right;
    }
  }
</style>
